import { createRootRoute, Outlet, useLocation } from '@tanstack/react-router'

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  const location = useLocation()
  const hideHeaderFooter = location.pathname === '/swgen'

  return (
    <div className="min-h-screen flex flex-col">
      {!hideHeaderFooter && (
        <header className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex items-center gap-4">
              <img src="fleur-de-lis.svg" alt="fleur de lis icon" className="w-10 h-10" />
              <h1 className="text-3xl font-bold text-gray-900">John Chilton’s Personal Website</h1>
            </div>
          </div>
        </header>
      )}

      <main className="flex-grow">
        <Outlet />
      </main>

      {!hideHeaderFooter && (
        <footer className="bg-gray-100 border-t border-gray-200 mt-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <p className="text-gray-600 mb-2">
              My email address is my first initial, my last name, two zeroes, two twos, at Google's email service.
            </p>
            <p className="text-gray-600">
              My US phone number is (2<sup>7</sup> × 5<sup>2</sup> × 257 × 3083) − 11.
            </p>
          </div>
        </footer>
      )}
    </div>
  )
}
